import {
  SET_COMPANY_DIRECTORY,
  UPDATE_CONTACT_ERRORS,
  UPDATE_CONTACTS,
  UPDATE_CONTACTS_ACCORDION_ERROR,
  UPDATE_CONTACTS_MODE,
  UPDATE_CUSTOM_ROUTING_QUESTION,
  UPDATE_CUSTOM_ROUTING_QUESTION_ERROR,
  UPDATE_IS_CUSTOM_ROUTING_QUESTION,
  UPDATE_OPEN_CONTACTS,
  UPDATE_SYNC_DOMAIN,
} from "../actions/CompanyDirectoryActions";

const initialState = {
  contacts: [],
  updatedContacts: [],

  contactErrors: [],
  noDestinationsError: "",

  contactsAccordionError: null,

  openContacts: [],

  contactsMode: "netsapiens",
  updatedContactsMode: "netsapiens",
  supportedContactsInputMethods: [{ id: "manual-input", label: "Manual Input" }],

  netsapiensSyncDomain: "",
  updatedNetsapiensSyncDomain: "",

  config: {
    minNameCharacters: 2,
    maxNameCharacters: 30,
    minDescriptionCharacters: 0,
    maxDescriptionCharacters: 100,
    minEmailCharacters: 5,
    maxEmailCharacters: 100,
    minContactListSize: 0,
    maxContactListSize: 100,
    maxContactDestinations: 30,
  },
};

const companyDirectoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPANY_DIRECTORY:
      return {
        ...state,
        contacts: action.payload.contacts ? JSON.parse(JSON.stringify(action.payload.contacts)) : [],
        updatedContacts: action.payload.contacts ? JSON.parse(JSON.stringify(action.payload.contacts)) : [],
        contactsMode: action.payload.contactsMode || state.contactsMode,
        updatedContactsMode: action.payload.contactsMode || state.contactsMode,
        supportedContactsInputMethods:
          action.payload.supportedContactsInputMethods || state.supportedContactsInputMethods,
        netsapiensSyncDomain: action.payload.netsapiensSyncDomain || state.netsapiensSyncDomain,
        updatedNetsapiensSyncDomain: action.payload.netsapiensSyncDomain || state.netsapiensSyncDomain,
        config: { ...state.config, ...action.payload.config } || state.config,
      };

    case UPDATE_CONTACTS:
      return {
        ...state,
        updatedContacts: [...action.payload],
        contactsAccordionError: null,
      };
    case UPDATE_OPEN_CONTACTS:
      return {
        ...state,
        openContacts: action.payload,
      };
    case UPDATE_CONTACT_ERRORS:
      return {
        ...state,
        contactErrors: action.payload,
      };
    case UPDATE_CONTACTS_ACCORDION_ERROR:
      return {
        ...state,
        contactsAccordionError: action.payload,
      };
    case UPDATE_CONTACTS_MODE:
      return {
        ...state,
        updatedContactsMode: action.payload,
      };
    case UPDATE_SYNC_DOMAIN:
      return {
        ...state,
        updatedNetsapiensSyncDomain: action.payload,
      };
    case "CANCEL": {
      return {
        ...state,
        updatedContacts: JSON.parse(JSON.stringify(state.contacts)), // Deep copy
        updatedContactsMode: state.contactsMode,
        updatedNetsapiensSyncDomain: state.netsapiensSyncDomain,
        openContacts: [],
        contactErrors: [],
      };
    }
    case "SAVED": {
      return {
        ...state,
        contacts: JSON.parse(JSON.stringify(state.updatedContacts)), // Deep copy
        contactsMode: state.updatedContactsMode,
        netsapiensSyncDomain: state.updatedNetsapiensSyncDomain,
        openContacts: [],
        contactErrors: [],
      };
    }
    default:
      return state;
  }
};

export default companyDirectoryReducer;
